import { WhatsappLogo } from "@phosphor-icons/react";
import { BRAND } from "@/data/services";

// Sticky one-tap WhatsApp button — visible on every public page bottom-right.
// Uses the official WhatsApp green (#25D366) and respects mobile safe-area.
export default function WhatsAppFab() {
  return (
    <a
      href={BRAND.whatsapp_url}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={`Chat on WhatsApp ${BRAND.phone_display}`}
      data-testid="whatsapp-fab"
      className="fixed z-40 bottom-5 right-5 md:bottom-7 md:right-7 group inline-flex items-center gap-2 pl-3.5 pr-4 h-14 rounded-full bg-[#25D366] text-white shadow-lg shadow-emerald-900/25 hover:bg-[#1FB855] hover:shadow-emerald-900/40 transition-all hover:-translate-y-0.5"
      style={{
        paddingBottom: "max(0px, env(safe-area-inset-bottom, 0px))",
      }}
    >
      <WhatsappLogo size={26} weight="fill" aria-hidden="true" />
      <span className="hidden sm:inline font-medium text-sm whitespace-nowrap">
        Chat on WhatsApp
      </span>
      <span
        className="absolute inset-0 -z-10 rounded-full bg-[#25D366] opacity-60 animate-ping"
        aria-hidden="true"
      />
    </a>
  );
}
